import { render, staticRenderFns } from "./jcoUpdate.vue?vue&type=template&id=1ede02a4&scoped=true&"
import script from "./jcoUpdate.vue?vue&type=script&lang=js&"
export * from "./jcoUpdate.vue?vue&type=script&lang=js&"
import style0 from "./jcoUpdate.vue?vue&type=style&index=0&id=1ede02a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ede02a4",
  null
  
)

export default component.exports